import React from 'react';

const UnoHome = () => {
  return (
    <section className="about-section pb-10">
      <div className="container mt-lg-3 mt-xl-0">
        <div className="row clearfix align-items-xl-center">
          {/* Columna de imágenes */}
          <div className="col-lg-6 mb-2-9 mb-lg-0 position-relative">
            <div className="row">
              <div className="col-6 wow fadeInUp" data-wow-delay="200ms">
                <div className="image-hover">
                  <img src="/assets/img/home/index-piso-caucho.jpg" className="rounded" alt="..." />
                </div>
              </div>
              <div className="col-6 mt-1-9 wow fadeInUp" data-wow-delay="300ms">
                <div className="image-hover">
                  <img src="/assets/img/home/index-contenedor.jpg" className="rounded" alt="..." />
                </div>
              </div>
            </div>
          </div>

          {/* Columna de texto */}
          <div className="col-lg-6 text-column wow fadeIn" data-wow-delay="400ms">
            <div className="ps-xl-2-9">
              <div className="title-style3">
                <h2 className="h1 mb-4">En Decototal somos una comercializadora con más de 20 años en el mercado.</h2>
              </div>
              <p className="mb-1-9 lead text-dark font-weight-600">
              Nos especializamos en la distribución de productos de alta calidad, incluyendo recubrimientos para pisos y muros que son sustentables y libres de mantenimiento.
              </p>

              <div className="d-sm-flex align-items-center">
                <div className="me-sm-1-9 mb-3 mb-sm-0">
                  <ul className="social-icon-style3 mb-0 list-unstyled">
                    <li>
                    <a href="https://wa.me/+525620863653?text=Hola,%2C%20quisiera%20más%20información%20de%20sus%20productos." target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-whatsapp"></i>
                    </a>

                    </li>
                  </ul>
                </div>
                <a className="butn-style3" href="contacto-decototal">¡Cotiza Ahora!</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="circle-md left-5 top-75 border-secondary-color d-none d-xl-block"></div>
    </section>
  );
};

export default UnoHome ;
